import { MODALS_ID } from '../../../constants'

import { Button } from '../../../components/button'
import { Modal } from '../../../components/modal'
import { Text } from '../../../components/text'

function SuccessAddressModal({ onDismiss }: { onDismiss: () => void }) {
  return (
    <Modal id={MODALS_ID.SUCCESS_ADDRESS}>
      <Text size={16} weight={500} $textAlign="center">
        자택 주소가 등록되었어요.
      </Text>
      <Modal.Footer>
        <Button type="primary" block={true} onClick={onDismiss}>
          확인
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default SuccessAddressModal
